<template>
  <div class="tab">
    <div class="title">
      <div class="item" v-for="(t,i) in tabs" :key="`tab_${i}`" @click="change(i)" :selected="t.selected&&true">
        <span v-text="t.name"></span>
      </div>
    </div>
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'Tab',
  data () {
    return { tabs: [] }
  },
  props: {
    items: {
      type: Array
    }
  },
  mounted () {
    this.items.forEach((d, i) => {
      this.tabs.push({ name: d, selected: (i === 0 && true) || false })
    })
  },
  methods: {
    change (i) {
      // 其他全部取消
      this.tabs.forEach((t, index) => {
        if (i === index) {
          t.selected = true
        } else {
          t.selected = false
        }
      })
      this.$emit('change', i)
    }
  }
}
</script>

<style scoped lang="less">
.tab {
  .title {
    display: flex;
    .item:last-child {
      margin-right: 0px;
    }
    .item[selected] {
      color: rgba(28, 50, 79, 1);
      border-bottom: 2px solid #39D474;
    }
    .item {
      cursor: pointer;
      margin-right: 30px;
      padding: 8px 0px;
      font-size: 18px;
      font-weight: 600;
      color: rgba(207, 218, 234, 1);
    }
  }
}
</style>
